/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateVariantSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import {
    getProductState,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

type OwnProps = WidgetProps &
    HasProduct &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    productDetails: state.pages.productDetails,
    variantTraits: getProductState(state, ownProps.parentProductId).value?.variantTraits,
    variantProductState: getProductState(state, state.pages.productDetails.selectedProductId),
});

const mapDispatchToProps = {
    updateVariantSelection,
};

const ProductDetailsClearOptions: React.FC<OwnProps> = ({
    product,
    variantSelectionCompleted,
    updateVariantSelection,
    variantTraits,
    parentProductId,
}) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    const resetVariantselection = () => {
        if (variantTraits && variantTraits.length) {
            for (let i = 0; i < variantTraits.length; i++) {
                updateVariantSelection({
                    traitValueId: "",
                    variantTraitId: variantTraits[i].id,
                    productId: parentProductId,
                } as any);
            }
        }
    };

    return (
        <StyledWrapper>
            {variantSelectionCompleted && (
                <Link css={css`margin-top: 10px`} onClick={resetVariantselection}>
                    <Typography>{translate("Clear Options/Selections")}</Typography>
                </Link>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(
        connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsClearOptions)),
    ),
    definition: {
        displayName: "Product Clear Options",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
